import React, { setGlobal } from "reactn";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
// import './App.scss';



const upDateCurrentWorkItem = (id) => {
    setGlobal({selectedWork:id})
}

const Work = (props) => {
    const posts = props.posts.map(post => {
      // CHANGE THIS WITH HOME LOOP
      if (post.title) {
        return ( 

          <li class="col-sm-6 grid-item grid-item--work">	
            
            <div class="inner">
             <Link
                  to={`/works/${post.slug}`}
                  onClick={() => upDateCurrentWorkItem(post.id)}
              >
              <div class="grid-item__image">
                <img src={post.acf.logo.sizes.large} />
                <div class="grid-item__overlay">
                <img src={post.acf.logo_hover.sizes.large} />
                  
                </div>
              </div>

              </Link>
             
            </div>
          </li>
        );
      }
    });
   if (props.page.title) {
      return (
        <div className="home-page">
            <div className="row">
            <div className="col-12">
                <div className="intro-text" dangerouslySetInnerHTML={{__html: props.page.content.rendered}}>
                
                </div>
              </div>
            </div>
            <div className="row">
              {posts}
            </div>
        </div>
      )
    } else {
      return (
        <div className="intro-text">
          <p>loading...</p>        
        </div>
        
      )
    }
}

export default Work;
